import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import { defineRoleCenterSite } from "../handleAccessRoles";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchData = async (
  lng = "english",
  { page, limit, name, type, id, center, roleBasedQuery = true, q, code }
) => {
  try {
    const user = await getStorage();

    const { centerSiteRole } = await defineRoleCenterSite();

    // The landing page lists a centre's sites to visitors who have not
    // logged in. Anonymous callers use the public listing; see
    // bloodCenterQuery for the same split.
    const isAnonymous = !user?.token;

    const options = isAnonymous
      ? {
          method: "GET",
          url: `${API_URL}/bloodCenterSite/public`,
          params: {
            page: page,
            limit: limit,
            center,
            q: q && q !== "" ? q : undefined,
          },
        }
      : {
          method: "GET",
          url: `${API_URL}/bloodcentersite`,
          params: {
            page: page,
            limit: limit,
            name,
            id: center
              ? undefined
              : id || (roleBasedQuery ? centerSiteRole : undefined),
            center,
            q: q && q !== "" ? q : undefined,
            code,
          },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      const data = (queryRes?.data?.data || queryRes.data).map((el) => {
        return {
          ...el,
          label: el.code + " - " + el.name,
          value: el._id,
        };
      });

      return data;
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_site);
  }
};

export default fetchData;

export const deleteCenterSite = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/bloodcentersite`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_center_site);
  } catch (error) {
    toastMessage("error", language[lng].error_delete_center_site);
  }
};
